<template>
    <v-card class="mx-auto draggable-card"  outlined :style="cardStyle"  @mousedown="onMouseDown" style="max-width:15rem">
            <div style="position:absolute;width:100%;"><v-icon  style="font-size: 1.5rem;cursor:pointer;position:relative;left: 77%;
                ;top: -19px;" @click="close">mdi-close</v-icon></div>
            <div style="margin-bottom:.6rem"><h5>{{hoveredItem.PACIENTE}}</h5></div>
            <div class="container-span"><h6 class="container-datos">IECA:</h6><span class="container-resultados">{{dataPaciente.IECA}}</span></div>
            <div class="container-span"><h6 class="container-datos">DOSIS_IECA:</h6><span class="container-resultados">{{dataPaciente.DOSIS_IECA}}</span></div>
            <div class="container-span"><h6 class="container-datos">ARA_2 :</h6><span class="container-resultados">{{dataPaciente.ARA_2}}</span></div>
            <div class="container-span"><h6 class="container-datos">DOSIS_ARA_2 :</h6><span class="container-resultados">{{dataPaciente.DOSIS_ARA_2}}</span></div>
            <div class="container-span"><h6 class="container-datos">CALCIO_ANTAGON :</h6><span class="container-resultados">{{dataPaciente.CALCIO_ANTAGON}}</span></div>
            <div class="container-span"><h6 class="container-datos">DOSIS_CALCIO_ANTAGON :</h6><span class="container-resultados">{{dataPaciente.DOSIS_CALCIO_ANTAGON}}</span></div>
            <div class="container-span"><h6 class="container-datos">ACC_SNC :</h6><span class="container-resultados">{{dataPaciente.ACC_SNC}}</span></div>
            <div class="container-span"><h6 class="container-datos">DOSIS_ACC_SNC :</h6><span class="container-resultados">{{dataPaciente.DOSIS_ACC_SNC}}</span></div>
            <div class="container-span"><h6 class="container-datos">BETABLOQ :</h6><span class="container-resultados">{{dataPaciente.BETABLOQ}}</span></div>
            <div class="container-span"><h6 class="container-datos">DOSIS_BETABLOQ :</h6><span class="container-resultados">{{dataPaciente.DOSIS_BETABLOQ}}</span></div>
            <div class="container-span"><h6 class="container-datos">OBSERVACIONES :</h6><span class="container-resultados">{{dataPaciente.OBSERVACIONES}}</span></div>
        </v-card>
</template>
<style scoped>
.container-resultados{
    font-size: .8rem;
}
.container-span{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.container-datos{
    font-size: .8rem;
    margin-right: .5rem;
    font-weight: 400;
}
.canvas-container {
    position: relative;
    margin: auto;
    height: 600px;
    width: 600px;
}

.chart-card {
    height: 400px;
}

.chart-card canvas {
    width: 100% !important;
    height: 100% !important;
}

.v-dialog__content--active {
    background: #59595940;
    backdrop-filter: blur(1px);
}
.draggable-card {
  cursor: move;
  padding: 1.5rem;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
    props: ["hoveredItem", "fechaDialog"],
    data() {
        return {
            cardPosition: { top: 400, left: 1300 },
            isDragging: false,
            dragStart: { x: 0, y: 0 },
            months: [
                "Pacientes Diálisis",
                "Unidades Actuales",
                "Eventos Accesos Vasculares",
                "Morbilidades Hospitalarias",
                "Resultados Clínicos",
                "Calidad Microbiológica",
                "Vacunaciones",
            ],
            enrolledPatients: [2, 3, 4, 5, 6, 7, 8], // Example data
            notEnrolledPatients: [1, 2, 3, 1, 2, 1, 8], // Example data
            chart: null,
            chartData1: [],
            dialogLoader: false,
            title: "Hemoglobina",
            labelColum: [],
            dataPaciente:[]
        };
    },
    watch: {
        hoveredItem(newValue, oldValue) {
            this.dataInit();
        }
    },
    methods: {
        onMouseDown(event) {
            this.isDragging = true;
            this.dragStart.x = event.clientX - this.cardPosition.left;
            this.dragStart.y = event.clientY - this.cardPosition.top;
            document.addEventListener("mousemove", this.onMouseMove);
            document.addEventListener("mouseup", this.onMouseUp);
        },
        onMouseMove(event) {
            if (this.isDragging) {
                this.cardPosition.left = event.clientX - this.dragStart.x;
                this.cardPosition.top = event.clientY - this.dragStart.y;
            }
        },
        onMouseUp() {
            this.isDragging = false;
            document.removeEventListener("mousemove", this.onMouseMove);
            document.removeEventListener("mouseup", this.onMouseUp);
        },
        close() {
            this.$emit("closeHistorial");
        },
        saveDate() {
            // Ejecuta la lógica adicional
            this.loadPeriodo();
            // Luego ejecuta la función de guardado del diálogo
            this.$refs.dialog.save(this.date);
        },
        closeDialog() {
            this.dialogImport = false;
            this.dataInit();
        },
        dataInit() {
            this.isLoading = true;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_consulta_resultado_hta/", { autogen : this.hoveredItem.autogenerado, fecha: this.fechaDialog }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.isLoading = false;
                            this.dataPaciente = res.data.length!=0?res.data[0]:res.data;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
    },
    mounted() {
       
    },
    beforeDestroy() {
        if (this.chart) {
            this.chart.destroy();
        }
    },
    computed: {
        cardStyle() {
      return {
        position: "fixed",
        top: `${this.cardPosition.top}px`,
        left: `${this.cardPosition.left}px`,
        zIndex: 10,
        marginBottom: "1rem",
      };
    },
    },
    created() {
        this.dataInit();
    },
    components: {  },
};
</script>